<script setup lang="ts"></script>

<template>
  <div class="px-3">
    <slot />
  </div>
</template>
